import { environment } from "src/environments/environment";

export const API_URL: string = environment.api_url;

export const API_ENDPOINTS = {
  loginUser: "api/Auth/superadmin/Token",
  getAllSubscriptionPlans: "api/Products",
  tenants: "api/Tenants",
  cloneTenants: "api/Tenants/GetListCloneAccount",
  enableDisableCompany: "api/Tenants/enableordisable",
  setTestAccount: "api/Tenants/settestaccount",
  tenantDetails: "api/TenantSubscription",
  setProductPopularity: "api/Products/SetAsMostPopular",
  enableDisableProductActivity: "api/Products/EnableOrDisable",
  cancelSubscription: "api/TenantSubscription/CancelSubscription",
  refundSubscription: "api/TenantSubscription/refundSubscription",
  UpdateEmail: "api/Auth/superadmin/UpdateEmail",
  UpdatePassword: "api/Auth/superadmin/UpdatePassword",
  updateSubscriptionFeature: "api/TenantSubscription/UpdateSubscriptionFeature",
  
  // Dashboard / Homepage Data
  dashboardData: "api/TenantSubscription/CompaniesSubscriptionsDetails",

  // Settings
  settings: "api/Settings",
  Taskslist: "api/Tasks/list",
  ProjectList: "api/Project/GetProjectList",
  EstimateList: "api/Estimate/list",
  InvoiceList: "api/Invoice/list",
  FileList: "api/Photo/GetAllPhotos",
  EmployeeList: "api/Worker/GetAllEmployees",
  ContractorList: "api/Contractors/list",
  CustomerList: "api/Customers/list",
  ImpersonateUser:'api/superadmin/ImpersonateUser',
  getPortalSetting: 'api/superadmin/gettenantsettings',
  saveTenantSettings:'api/superadmin/savecompanysettings',
  UnlockInvoiceStatus:'api/superadmin/UnlockInvoice',
  DowngradeUser:'api/superadmin/DowngradeUser',
  ExtendTrial:'api/superadmin/ExtendTrial',
  ConvertTrialToSubscription:'api/superadmin/ConvertTrialToSubscription',
  CheckStripeSubscriptionExists:'api/superadmin/CheckStripeSubscriptionExists',
  changeInvoiceStatus:'api/superadmin/ChangeInvoiceStatus',
  RemoveSignatureFromEstimate:'api/superadmin/RemoveSignatureFromEstimate',
  RemoveInvoicesFromEstimate:'api/superadmin/RemoveInvoicesFromEstimate',
  ArchiveEmployee:'api/Superadmin/ArchiveEmployee',
  tradesList:'api/Superadmin/tradesList',
  AddUpdateEmployee:'api/Superadmin/AddUpdateEmployee',

  //mapbox urls
  getAllEmployess: 'api/Worker/GetEmployeesList',
  saveGeoLocationPoints: 'api/GeoLocation/SaveUserCoordinate',
  getAllGeoLocationPoints: 'api/GeoLocation/GetUserCoordinateList',

  //clone account
  cloneAccount:'api/ProjulAccountClone/AddProjulCloneAccount',
  //Features
  Save1buildFeatureSettings: "api/ProjulFeatures/save1buildFeatureSettings",
  GetFeatureDetails:'api/ProjulFeatures/getFeatureDetails',

  CompanyStripeCoupon:'api/Superadmin/CompanyStripeCoupon',
  SaveCompanyStripeCoupon:'api/Superadmin/SaveCompanyStripeCoupon',
  PricingChangeAcknowledgement:'api/Superadmin/PricingChangeAcknowledgement',
  killQBJobs:'api/Superadmin/KillQBJobs',
  GetTenant:'api/Tenants/GetTenant',
  deletedItems:'api/Superadmin/DeletedItems',
  getDeletedInvoicesForEstimate:'api/Superadmin/GetDeletedInvoicesForEstimate',
  restoreDeletedItem:'api/Superadmin/RestoreDeletedItem',
  bulkRestoreDeletedItems:'api/Superadmin/BulkRestoreDeletedItems',
  getRestoreContext:'api/Superadmin/GetRestoreContext',
  estimateHistory:'api/Superadmin/EstimateHistory',
  restoreEstimate:'api/Superadmin/RestoreEstimate',
  bulkDeleteCustomers:'api/Superadmin/BulkDeleteCustomers',
  getCustomerDeletionPreview:'api/Superadmin/GetCustomerDeletionPreview',

  // Cost Items
  getCostItems:'api/Superadmin/GetCostItems',
  bulkDeleteCostItems:'api/Superadmin/BulkDeleteCostItems',
  getCostItemDeletionPreview:'api/Superadmin/GetCostItemDeletionPreview',

  // Email Logs
  emailLogsPaginated: 'api/EmailLog/GetPaginatedEmailLogs',
  getCompaniesDropdown: 'api/EmailLog/GetLicenseCompaniesDropdown',

  // Employee Password Management
  sendPasswordReset: 'api/Superadmin/SendPasswordReset',
  setEmployeePassword: 'api/Superadmin/SetEmployeePassword',
  forceRefreshUser: 'api/Superadmin/ForceRefreshUser',

  // Estimate Template Import/Export
  listEstimateTemplates: 'api/Superadmin/ListEstimateTemplates',
  exportEstimateTemplates: 'api/Superadmin/ExportEstimateTemplates',
  importEstimateTemplates: 'api/Superadmin/ImportEstimateTemplates',
  deleteEstimateTemplate: 'api/Superadmin/DeleteEstimateTemplate',

  // Schedule Template Import/Export
  listScheduleTemplates: 'api/Superadmin/ListScheduleTemplates',
  exportScheduleTemplates: 'api/Superadmin/ExportScheduleTemplates',
  importScheduleTemplates: 'api/Superadmin/ImportScheduleTemplates',
  deleteScheduleTemplate: 'api/Superadmin/DeleteScheduleTemplate',

  // Usage Metrics
  getTenantUsageSummary: 'api/Superadmin/GetTenantUsageSummary',
  getTenantUsageDetails: 'api/Superadmin/GetTenantUsageDetails',
  getTenantUsageTrends: 'api/Superadmin/GetTenantUsageTrends',
  getTenantUsageMetricDetail: 'api/Superadmin/GetTenantUsageMetricDetail',
  getTenantUserActivityDetail: 'api/Superadmin/GetTenantUserActivityDetail',
  getFleetUsageOverview: 'api/Superadmin/GetFleetUsageOverview',
  getFleetFeatureAdoptionHistory: 'api/Superadmin/GetFleetFeatureAdoptionHistory',
  getActiveUsersSeries: 'api/Superadmin/GetActiveUsersSeries',
  getFeatureAdoptionRules: 'api/Superadmin/GetFeatureAdoptionRules',
  getFeatureAdoptionThresholds: 'api/Superadmin/GetFeatureAdoptionThresholds',
  runUsageMetricsRollup: 'api/Superadmin/RunUsageMetricsRollup',
  getUsageRollupStatus: 'api/Superadmin/GetUsageRollupStatus',

  // User Search
  searchUsers: 'api/superadmin/search',
  allPortalUsers: 'api/superadmin/AllPortalUsers',

  // Projul Connect operator levers (ConnectSuperadminController — superadmin-only).
  // Note these sit on their own controller, not api/Superadmin.
  connectSuspend: 'api/ConnectSuperadmin/suspend',
  connectQuotaOverride: 'api/ConnectSuperadmin/quota-override',
  connectRevokeKey: 'api/ConnectSuperadmin/revoke-key',
  connectMintKey: 'api/ConnectSuperadmin/mint-key',
  connectRotateKey: 'api/ConnectSuperadmin/rotate-key',
  connectShareLink: 'api/ConnectSuperadmin/share-link',
  connectShareLinkEmail: 'api/ConnectSuperadmin/share-link/email',
  connectKeys: 'api/ConnectSuperadmin/keys',
  connectUsage: 'api/ConnectSuperadmin/usage',
  // §12.3 rate-limit overrides. GET reads a tenant's knobs; POST is a whole-set replace.
  connectRateLimits: 'api/ConnectSuperadmin/rate-limits'
};
